import { render, staticRenderFns } from "./exitPrompt.vue?vue&type=template&id=c28bff54&scoped=true&"
import script from "./exitPrompt.vue?vue&type=script&lang=js&"
export * from "./exitPrompt.vue?vue&type=script&lang=js&"
import style0 from "./exitPrompt.vue?vue&type=style&index=0&id=c28bff54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28bff54",
  null
  
)

export default component.exports